// ServiceCards.js
import React from "react";
import { FaWallet } from "react-icons/fa";
import "../styles/serviceCard.css";
import {Link} from "react-router-dom"; 


const ServiceCard = () => {
  const services = [
    {
      icon: <FaWallet />,
      title: "Instant Wallet Funding",
      description:
        "Yes, we got you covered. Enjoy easy, fast and instant funding of your wallet after payment. You will receive your personal SubnetExpress.com bank account details for instant funding of wallet after registration. Any payment made into the bank account gets your wallet credited automatically. Oh my goodness",
      buttonText: "Fund Your Wallet",
        borderColor: "#0C464A", // Deep teal
    },
  ];

  return (
     <div className="cards-container">
      {services.map((card, index) => (
        <div key={index} className="service-card" style={{ borderTopColor: card.borderColor }}>
          <div className="card-icon-wrapper" style={{ backgroundColor: card.borderColor }}>
            <div className="card-icon">{card.icon}</div>
          </div>
          <h5>{card.title}</h5>
          <p>{card.description}</p>
           <Link to="/dashboard" className="my-cstm-btn-link">
          <button className="card-btn">{card.buttonText}</button>
         </Link> 
        </div>
      ))}
    </div>
  );
};

export default ServiceCard;
